export default () => {
  if (document.querySelector('.g-recaptcha')) {
    return import(/* webpackChunkName: "lazy-load-scripts" */ '../components/lazy-load/lazy-load-scripts')
      .then(({ default: LazyLoadScript }) => new LazyLoadScript('.g-recaptcha', 'https://www.google.com/recaptcha/api.js?hl='))
      .catch((error) => `Lazy load : ${error}`);
  }
  return null;
};
